"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var HeaderStyles = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        marginBottom: theme.spacing(8),
        maxWidth: 980,
        '.onHover': {
            visibility: 'hidden',
        },
        '&:hover .onHover': {
            visibility: 'visible',
        },
    });
});
var Header = function (_a) {
    var item = _a.item;
    return ((0, jsx_runtime_1.jsxs)(HeaderStyles, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center", mb: 3, mt: 7 }, { children: [(0, jsx_runtime_1.jsx)(Logo_1.default, { brand: item, size: "xl", fullWidth: true }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1, ml: 1.5, noWrap: true }, { children: item.name || "Company (".concat(item.id, ")") }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "onHover" }, { children: item.id }))] }));
};
exports.default = Header;
